import { locale } from '@trqk/utils';

import { HASHES } from '../../../constants';

export const sectionMap: Record<string, HeaderSection> = {
    explorer: {
        id: HASHES.STATEMENTS.EXPLORER,
        label: locale.enUS.STATEMENTS.SECTIONS.EXPLORER.SECTION_TITLE,
        name: 'explorer',
    },
    earningsAndRanges: {
        id: HASHES.STATEMENTS.EARNINGS_AND_RANGES,
        label: locale.enUS.STATEMENTS.SECTIONS.EARNINGS_AND_RANGES
            .SECTION_TITLE,
        name: 'earningsAndRanges',
    },
    breakdown: {
        id: HASHES.STATEMENTS.BREAKDOWN,
        label: locale.enUS.STATEMENTS.SECTIONS.BREAKDOWN.SECTION_TITLE,
        name: 'breakdown',
    },
    regions: {
        id: HASHES.STATEMENTS.REGIONS,
        label: locale.enUS.STATEMENTS.SECTIONS.REGIONS.SECTION_TITLE,
        name: 'regions',
    },
};

export const sections: HeaderSection[] = [
    sectionMap.explorer,
    sectionMap.earningsAndRanges,
    sectionMap.breakdown,
    sectionMap.regions,
];

export const sectionIds = sections.map(({ id }: HeaderSection): string => id);

export const defaultSectionConfigs = [
    {
        section: sectionMap.explorer,
        render: true,
    },
    {
        section: sectionMap.earningsAndRanges,
        render: true,
    },
    {
        section: sectionMap.breakdown,
        render: true,
    },
    {
        section: sectionMap.regions,
        render: true,
    },
];
